export type AnalyticsTab = {
  key: string;
  label: string;
  dashboardKey: string;
};

export type AnalyticsPage = {
  path: string;
  title: string;
  tabs: AnalyticsTab[];
};

export const analyticsPages = {
  onShelfAvailability: {
    path: "/analytics/on-shelf-availability",
    title: "On-Shelf Availability",
    tabs: [
      { key: "availability", label: "Availability", dashboardKey: "on-shelf-availability" },
      { key: "execution-analysis", label: "Execution Analysis", dashboardKey: "on-shelf-availability" },
      { key: "tasks", label: "Tasks", dashboardKey: "on-shelf-availability" },
    ],
  },
} as const satisfies Record<string, AnalyticsPage>;
